export default __webpack_public_path__ + "static/media/bubble_nova_l1.8ffa34a7.png";